import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCube = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.198 42.483 9.184 34.816a3.43 3.43 0 0 1-1.24-1.242 3.4 3.4 0 0 1-.444-1.726V16.602q0-.915.443-1.682.444-.769 1.24-1.286L22.26 5.89a3.44 3.44 0 0 1 1.735-.46q.928 0 1.788.46l13.076 7.743q.752.502 1.197 1.275a3.34 3.34 0 0 1 .444 1.693v15.246q0 .96-.447 1.726a3.44 3.44 0 0 1-1.255 1.242l-13.152 7.667q-.873.503-1.753.503t-1.695-.503m.466-2.91V24.935l-12.435-7.069v13.889q0 .187.095.354.094.165.283.283zm2.691 0 12.075-7.196a.8.8 0 0 0 .284-.283.7.7 0 0 0 .094-.355V17.865l-12.453 7.07zM24 22.492l12.415-7.124L24.378 8.42A.84.84 0 0 0 24 8.326a.84.84 0 0 0-.378.094l-12.037 6.947z" })
});
export default SvgCube;
